import { useMemo } from 'react';
import useSWR from 'swr';

import { request } from '~/api/_utils/request';
import { usePaginationSWR } from '~/api/_utils/usePaginationSWR';
import { useSWRV1OrganizationById } from '~/api/v1/organizations/[id]/get';
import { PostT, PostType } from '~/state/post';
import { BasicPostT } from '~/state/post/BasicPostT';

const getPath = (uid?: string | number) => `/v2/organizations/${uid}/posts`;

type Query = {
  page?: number;
  uid: string | undefined;
  futures?: boolean;
  types?: PostType[];
};

export async function apiGetV2OrganizationByIdPosts({ page, uid, futures, types }: Query) {
  if (!uid) return [];
  const response = await request.GET<{ posts: PostT[] }>(getPath(uid), { page, futures, types });
  return response.posts;
}

export function useSWRV2OrganizationByIdPosts(query: Omit<Query, 'page'>) {
  const swr = usePaginationSWR({
    api: (page) => apiGetV2OrganizationByIdPosts({ page, ...query }),
    path: getPath(query.uid),
    keys: [`futures=${query.futures}`, `types=${query.types}`],
    lengthPerPage: 5,
  });

  return { ...swr, posts: swr.flattenData };
}
